import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';
class WebhookServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(params) {
    return super.getList({ ...params, items_per_page: 15 });
  }
  getAllItems() {
    return super.getList({ items_per_page: 100 });
  }
  createItem(params) {
    return this.pure_http.post('/webhooks', params);
  }
  getItem(id) {
    return this.http.get(`/${id}`);
  }
  editItem(id, params = {}) {
    return this.http.put(`/${id}`, params);
  }
}

export const WebhookService = new WebhookServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'webhooks'
});
